import useFetchHelpCenter from 'app/hooks/fetch/useFetchHelpCenter';
import useFeatureFlags from 'app/hooks/useFeatureFlags';

export default function useLogo() {
  const { data: helpCenter } = useFetchHelpCenter();
  const { uiRefreshDisableLogo } = useFeatureFlags();
  const defaultLogo = {
    logoUrl: '',
    logoLink: '',
  };

  if (uiRefreshDisableLogo) {
    return defaultLogo;
  }

  if (helpCenter?.customization?.customer_logo_url) {
    return {
      logoUrl: helpCenter.customization.customer_logo_url,
      logoLink: helpCenter.customization.customer_logo_redirect_link,
    };
  }

  if (helpCenter?.logo?.url) {
    return {
      logoUrl: helpCenter.logo.url,
      logoLink: helpCenter.logo.link,
    };
  }

  return defaultLogo;
}
